/* unplugin-vue-components disabled */import script from "./Manager.vue?vue&type=script&setup=true&lang=js"
export * from "./Manager.vue?vue&type=script&setup=true&lang=js"

import "./Manager.vue?vue&type=style&index=0&id=780cb931&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780cb931"]])

export default __exports__